import Button from "@shared/v2/Button";
import { MagnifyingGlassSolidV6 } from "@shared/v2/Icomoon";

const SearchEmptyState = ({ isInitialState, searchBarRef }) => {
  return (
    <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[16px] tw-mt-[206px]">
      <MagnifyingGlassSolidV6 size="xxxl" className="tw-text-theme-primary" />
      <p className="tw-text-gray-75 tw-text-18d tw-font-bold tw-m-0">
        {isInitialState ? "Search Listings" : "No matching results"}
      </p>
      <p className="tw-text-gray-75 tw-m-0">
        {isInitialState
          ? "Enter an address, MLS#, neighborhood, city, ZIP code, or county to search"
          : "Please try searching with another term"}
      </p>
      <Button size="medium" onClick={() => searchBarRef.current.focus()}>
        Search
      </Button>
    </div>
  );
};

export default SearchEmptyState;
